'use strict';

/* ■■■■■■ スムーススクロール ■■■■■■ */

(function ($) {
  $('a[href^="#"]').click(function () {

    /* ◆◆◆◆◆◆ 定義 ◆◆◆◆◆◆*/
    const speed = 500;                                                 // スクロールのスピード
    const href = $(this).attr("href");                                 // リンクを取得
    const target = $(href == "#" || href == "" ? 'html' : href);       // スクロール先の要素
    let position = target.offset().top;                                // スクロールする位置

    /* ◆◆◆◆◆◆ 処理 ◆◆◆◆◆◆*/
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

})(jQuery);


/* ■■■■■■ ハンバーガーメニュー ■■■■■■ */

(function ($) {

  /* ◆◆◆◆◆◆ 定義 ◆◆◆◆◆◆*/
  const $body = $('body');
  const $btn = $('.toggle_btn');
  const $mask = $('#mask');
  const open = 'open';
  let $navLink = $('.global-nav li a, .global-nav__button a');

  /* ◆◆◆◆◆◆ 処理 ◆◆◆◆◆◆*/
  // ariaの切り替え
  function changeAttr(s) {
    if (s === 'open') {
      $btn.attr('aria-label', 'メニューを閉じる');
      $('.global-nav').attr('aria-hidden', false);
    } else {
      $btn.attr('aria-label', 'メニューを開く');
      $('.global-nav').attr('aria-hidden', true);
    }
  }

  // メニューの開閉
  $btn.on('click', function () {
    if (!$body.hasClass(open)) {
      $body.addClass(open);
      changeAttr('open');
    } else {
      $body.removeClass(open);
      changeAttr('close');
    }
  });

  // 背景をクリックするとメニューを閉じる
  $mask.on('click', function () {
    $body.removeClass(open);
    changeAttr('close');
  });

  // リンクをクリックするとメニューを閉じる
  $navLink.each(function () {
    $(this).on("click", function () {
      $body.removeClass(open);
    });
  });
})(jQuery);


/* ■■■■■■ トップに戻るボタン ■■■■■■ */
$(function () {
  var topBtn = $('.scroll');
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
});


// Footer 固定
(function ($) {
  // header_down scroll
  var header = $('.bottom-fix'); // fixed DOM
  var adclass = 'scroll-down'; // add css class
  var scrollY = 400; // scroll 何ピクセルから表示

  $(window).scroll(function () {
    if ($(window).scrollTop() > scrollY) {
      header.addClass(adclass);
    } else {
      header.removeClass(adclass);
    }
  });
})(jQuery);

(function ($) {
  // header_down scroll MAX
  var header = $('.bottom-fix'); // fixed DOM
  var scroll_down = 'down_footer'; // add css class
  var scrollfooter = 3800; // scroll max　何ピクセルで非表示にする

  $(window).scroll(function () {
    if ($(window).scrollTop() > scrollfooter) {
      header.addClass(scroll_down);
    } else {
      header.removeClass(scroll_down);
    }
  });
})(jQuery);
// Footer 固定　end

/**
 * ■■■■■■ css画像遅延読み込み ■■■■■■
 * 対象要素が画面に入る直前に画像を読み込む
 *
 * 対象要素を監視し、ビューポートに入る100px手前でクラス(is-intersected)を付与する。
 * 初期の要素では画像を指定せず、クラスがついた要素で画像を指定する。
 *
 * 例)
 * .cv {
 *  background-size: cover;
 *    &.is-intersected {
 *      background-image: url({path});
 *    }
 * }
 *
 */

// 今回の交差を監視する要素
const boxes = document.querySelectorAll(".js-observe");

const options = {
  root: null, // 今回はビューポートをルート要素とする
  rootMargin: "100px 0px", // ビューポートのに交差する100px手前を判定基準とする
};
const observer = new IntersectionObserver(doWhenIntersect, options);

// それぞれのboxを監視する
boxes.forEach(box => {
  observer.observe(box);
});


/**
 * 交差したときに呼び出す関数
 * @param entries
 */
function doWhenIntersect(entries) {
  // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      activateIndex(entry.target);
      observer.unobserve(entry.target);
    }
  });
}

/**
 * クラスを付与する関数
 * @param element
 */
function activateIndex(element) {
  const addClass = 'is-intersected';
  element.classList.add(addClass);
}